module.exports = __webpack_public_path__ + "img/345-858d75.png";